import { z } from "zod";
import { IntlShape } from "react-intl";

import { getCompanyNameZodField, getJobTitleZodField, getAcceptPrivacyPolicyZodField } from "./getRegistrationSchema";

export function getGoogleFormSchema(intl: IntlShape, hasDeveloperSandbox: boolean) {
    return z.object({
        companyName: hasDeveloperSandbox
            ? getCompanyNameZodField(intl)
            : z.string(),
        jobTitle: hasDeveloperSandbox
            ? getJobTitleZodField(intl)
            : z.string(),
        acceptPrivacyPolicy: getAcceptPrivacyPolicyZodField(intl)
    });
}
